import Type from 'union-type'
import * as R from 'ramda'

function label(label, T) {
  T.prototype._type_label = label
}

var T_ = function() {
  return true
}
export const Maybe = Type({
  Just: [T_],
  Nothing: [],
})
Maybe.prototype.map = Maybe.prototype['fantasy-land/map'] = function(fn) {
  return Maybe.case(
    {
      Nothing: () => Maybe.Nothing,
      Just: v => Maybe.Just(fn(v)),
    },
    this
  )
}
Maybe.prototype.bind = Maybe.prototype['fantasy-land/chain'] = function(fn) {
  return Maybe.case(
    {
      Nothing: () => Maybe.Nothing,
      Just: v => Maybe.of(fn(v)),
    },
    this
  )
}
Maybe.prototype.ap = Maybe.prototype['fantasy-land/ap'] = function(mfn) {
  return Maybe.case(
    {
      Nothing: () => ma => Maybe.Nothing,
      Just: fn => ma =>
        Maybe.case(
          {
            Nothing: () => Maybe.Nothing,
            Just: a => Maybe.Just(fn(a)),
          },
          ma
        ),
    },
    mfn
  )(this)
}
// [()->Maybe<T>, ...] -> (() -> Maybe<T>)
Maybe.choose = R.reduce(
  (acc, elem) =>
    Maybe.case(
      {
        Nothing: () => acc,
        Just: v => R.reduced(() => Maybe.Just(v)),
      },
      elem()
    ),
  () => Maybe.Nothing
)
Maybe.of = v => {
  if (R.isNil(v)) {
    return Maybe.Nothing
  } else {
    return Maybe.prototype.isPrototypeOf(v) ? v : Maybe.Just(v)
  }
}
Maybe.valueOrDefault = R.curryN(2, function(defaultVal, maybe) {
  return Maybe.case(
    {
      Nothing: () => defaultVal,
      Just: v => v,
    },
    maybe
  )
})

export const MaybeOf = function(T) {
  let innerType = Type({
    T: [T],
  }).T
  let validate = v => {
    return (
      Maybe.prototype.isPrototypeOf(v) &&
      Maybe.case(
        {
          Nothing: () => true,
          Just: v => {
            try {
              innerType(v)
            } catch (e) {
              R.prop('log', console)(v) // eslint-ignore-line
              var label = R.path(['prototype', '_type_label'], T)
              label = label ? ' of ' + label : ''
              throw new TypeError(
                'wrong value ' + v + ' passed to type Maybe' + label
              )
            }
            return true
          },
        },
        v
      )
    )
  }
  return validate
}

export const Subjects = Type({
  State: [], // only 1 state here, that is Texas
  Region: {
    id: String,
    name: String,
  },
  District: {
    id: String,
    name: String,
  },
  Campus: {
    id: String,
    name: String,
  },
})

Subjects.prototype.displayText = function() {
  return Subjects.case(
    {
      State: () => 'State',
      Region: () => 'Region',
      District: () => 'District',
      Campus: () => 'Campus',
    },
    this
  )
}

Subjects.isState = sub => {
  return Subjects.case({
    State: () => true,
    _: () => false,
  })
}

Subjects.isRegion = sub => {
  return Subjects.case({
    Region: () => true,
    _: () => false,
  })
}

Subjects.isDistrict = sub => {
  return Subjects.case({
    District: () => true,
    _: () => false,
  })
}

Subjects.isCampus = sub => {
  return Subjects.case({
    Campus: () => true,
    _: () => false,
  })
}

export const ChartPattern = Type({
  StateVsRegions: [],
  Regions: [],
  RegionVsDistricts: [],
  Districts: [],
  DistrictVsCampuses: [],
  Campuses: [],
})
ChartPattern.prototype.displayText = function() {
  return ChartPattern.case(
    {
      StateVsRegions: () => 'State and its Regions',
      Regions: () => 'Regions',
      RegionVsDistricts: () => 'Region and its Districts',
      Districts: () => 'Districts',
      DistrictVsCampuses: () => 'District and its Campuses',
      Campuses: () => 'Campuses',
    },
    this
  )
}

export const ChartSelections = Type({
  StateVsRegions: {
    state: MaybeOf(Subjects.isState),
    regions: MaybeOf(Type.ListOf(Subjects.isRegion)),
  },
  Regions: [MaybeOf(Type.ListOf(Subjects.isRegion))],
  RegionVsDistricts: {
    region: MaybeOf(Subjects.isRegion),
    districts: MaybeOf(Type.ListOf(Subjects.isDistrict)),
  },
  Districts: [MaybeOf(Type.ListOf(Subjects.isDistrict))],
  DistrictVsCampuses: {
    district: MaybeOf(Subjects.isDistrict),
    campuses: MaybeOf(Type.ListOf(Subjects.isCampus)),
  },
  Campuses: [MaybeOf(Type.ListOf(Subjects.isCampus))],
})

export const ChartType = Type({
  CollegeEnrollment: [],
  Persistence: [],
  CollegeReadiness: [],
  AdvDualCoursesTaken: [],
  SAToACTParticipation: [],
  DAPRecommendedPlan: [],
  AttendanceRates: [],
  STAAROutcomes: [],
  TSIA: [],
})

ChartType.prototype.introComp = function() {
  return ChartType.case(
    {
      CollegeEnrollment: () => 'chart-v1-intro',
      Persistence: () => 'chart-v2-intro',
      CollegeReadiness: () => 'chart-v3-intro',
      AdvDualCoursesTaken: () => 'chart-v4-intro',
      SAToACTParticipation: () => 'chart-v5-intro',
      DAPRecommendedPlan: () => 'chart-v6-intro',
      AttendanceRates: () => 'chart-v7-intro',
      STAAROutcomes: () => 'chart-v8-intro',
      TSIA: () => 'chart-v9-intro',
      _: () => 'empty-intro',
    },
    this
  )
}

ChartType.prototype.requestUrl = function() {
  return ChartType.case(
    {
      CollegeEnrollment: () => '/api/v1/data/search',
      Persistence: () => '/api/v2/data/search',
      CollegeReadiness: () => '/api/v3/data/search',
      AdvDualCoursesTaken: () => '/api/v4/data/search',
      SAToACTParticipation: () => '/api/v5/data/search',
      DAPRecommendedPlan: () => '/api/v6/data/search',
      AttendanceRates: () => '/api/v7/data/search',
      STAAROutcomes: () => '/api/v8/data/search',
      TSIA: () => '/api/v9/data/search',
    },
    this
  )
}

ChartType.prototype.displayText = function() {
  return ChartType.case(
    {
      CollegeEnrollment: () => 'College Enrollment',
      Persistence: () => 'Persistence',
      CollegeReadiness: () => 'College Readiness',
      AdvDualCoursesTaken: () => 'Advanced/Dual Courses Taken',
      SAToACTParticipation: () => 'SAT/ACT Participation',
      DAPRecommendedPlan: () => 'DAP/Recommended Plan',
      AttendanceRates: () => 'Attendance Rates',
      STAAROutcomes: () => 'STAAR Outcomes',
      TSIA: () => 'TSIA',
    },
    this
  )
}

export const Metrics = Type({
  Metrics: [String],
})

// ChartType => Maybe<Array<Metrics>>
let chartTypeMetrics = ChartType.case({
  CollegeEnrollment: () => Maybe.Nothing,
  Persistence: () => Maybe.Nothing,
  CollegeReadiness: () => Maybe.Nothing,
  AdvDualCoursesTaken: () => {
    return Maybe.Just([
      'Advanced Course/Dual-Credit Course Completion (Grades 9-12 & 11-12)',
      'AP/IB Results',
      'TSIA, Advanced/Dual Courses, Postsecondary Credit',
    ])
  },
  SAToACTParticipation: () => Maybe.Nothing,
  DAPRecommendedPlan: () => {
    return Maybe.Just([
      'DLA/Foundation Plan & DAP/Recommended Plan Annual Graduates',
      'DLA/Foundation Plan & DAP/Recommended Plan Longitudinal Rates',
    ])
  },
  AttendanceRates: () => Maybe.Nothing,
  STAAROutcomes: () => {
    return Maybe.Just([
      'Approaches Grade Level (STAAR)',
      'Meets Grade Level (STAAR)',
      'Masters Grade Level (STAAR)',
    ])
  },
  TSIA: () => {
    return Maybe.Just(['TSI ELA Rates', 'TSI Math Rates'])
  },
})

ChartType.prototype.getMetrics = function() {
  return chartTypeMetrics(this)
}

export const Wizard = Type({
  Wizard: {
    chartType: MaybeOf(ChartType),
    chartPattern: MaybeOf(ChartPattern),
    chartSelection: MaybeOf(ChartSelections),
    metrics: MaybeOf(Type.ListOf(Metrics)),
  },
})

label('Maybe', Maybe)
label('Subjects', Subjects)
label('ChartType', ChartType)
label('ChartPattern', ChartPattern)
label('ChartSelections', ChartSelections)
label('Metrics', Metrics)
label('Wizard', Wizard)
